import styled from "styled-components";
import { colors } from "styles/theme";

export const UserBandwidthWrapper = styled.div`
  .cta-bandwidth span {
    color: ${colors.green};
    font-weight: bold;
  }
`;
